import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Function to draw header for delivery challan
const drawHeader = (doc, order, customer, site) => {
  const pageWidth = doc.internal.pageSize.width;
  const centerX = pageWidth / 2;
  const leftMargin = 5;
  const rightMargin = pageWidth - 5;

  // Header at the very top - Center aligned
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0); // Black color
  const challanText = 'DELIVERY CHALLAN';
  const challanY = 8;
  doc.text(challanText, centerX, challanY, { align: 'center' });

  // Underline the "DELIVERY CHALLAN" text
  const challanTextWidth = doc.getTextWidth(challanText);
  doc.setLineWidth(0.3);
  doc.line(
    centerX - (challanTextWidth / 2),
    challanY + 0.5,
    centerX + (challanTextWidth / 2),
    challanY + 0.5
  );

  // GSTIN - Center aligned
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.text('GSTIN : 27AAIPF9571F1Z1', centerX, 13, { align: 'center' });

  // Mobile and Email on same line - Center aligned
  doc.text('Mob : 9326260161          Email : saiply96@gmail.com', centerX, 17, { align: 'center' });

  // Company name - Large and centered
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(200, 52, 43); // Red color for company name
  doc.text('SAI PLYWOOD, HARDWARE', centerX, 24, { align: 'center' });
  doc.text('& ALUMINIUM CENTRE', centerX, 30, { align: 'center' });

  // Product description
  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  const productDesc = 'All Kinds Of Plywood (Greenply, Century, Modak, SP Platinum Kenstar) All Kinds of Wood-CP,';
  const productDesc2 = 'BTC, Salwood, Laminates, Veneers, ACP, Fiber cement board & Aluminum Pipes';
  doc.text(productDesc, centerX, 35, { align: 'center' });
  doc.text(productDesc2, centerX, 38, { align: 'center' });

  // Shop address
  doc.setFontSize(7);
  doc.setFont('helvetica', 'bold');
  const shopAddress = 'Shop No. 10, Nivan Bldg., Plot No. 96, Opp. Podar Int School, Khar (W) Mumbai 400 052.';
  doc.text(shopAddress, centerX, 42, { align: 'center' });

  // Draw horizontal line
  doc.setLineWidth(0.3);
  doc.setDrawColor(0, 0, 0);
  doc.line(leftMargin, 45, rightMargin, 45);

  // Challan details - Left side
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128); // Navy blue
  doc.text('DELIVERY', leftMargin, 50);
  doc.text('CHALLAN NO.', leftMargin, 54);

  // Display challan number
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(order.deliveryChallanNumber || order.delivery_challan_number || order.orderNumber || 'N/A', leftMargin + 35, 54);

  // Date - Right side
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128);
  doc.text('Date :', rightMargin - 35, 50);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  const deliveryDate = order.deliveryDate || order.delivery_date || order.updatedAt;
  doc.text(new Date(deliveryDate).toLocaleDateString('en-IN'), rightMargin - 15, 50);

  // Customer name (M/s.) and Site name
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text('M/s.', leftMargin, 60);
  doc.setFont('helvetica', 'bold');
  doc.text(customer.name || 'N/A', leftMargin + 12, 60);

  // Add site name below customer name if available
  const siteName = site ? (site.site_name || site.name) : null;
  if (siteName) {
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.text(`Site: ${siteName}`, leftMargin, 64);
  }

  // Vehicle details - Right side (vertical stack to prevent overflow)
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);

  let vehicleY = 60;
  const vehicleNumber = order.vehicleNumber || order.vehicle_number;
  const driverName = order.driverName || order.driver_name;
  const driverPhone = order.driverPhone || order.driver_phone;

  if (vehicleNumber) {
    doc.text(`Vehicle: ${vehicleNumber}`, rightMargin - 45, vehicleY, { align: 'left' });
    vehicleY += 3;
  }
  if (driverName) {
    doc.text(`Driver: ${driverName}`, rightMargin - 45, vehicleY, { align: 'left' });
    vehicleY += 3;
  }
  if (driverPhone) {
    doc.text(`Ph: ${driverPhone}`, rightMargin - 45, vehicleY, { align: 'left' });
  }
};

// Function to draw item table
const drawItemTable = (doc, order, isLastPage, startSerialNumber) => {
  const leftMargin = 5;
  const tableStartY = 68;

  // Prepare table columns with SR no. on the left
  const columns = [
    { header: 'SR.', dataKey: 'sr' },
    { header: 'PARTICULARS', dataKey: 'particulars' },
    { header: 'QTY.', dataKey: 'quantity' },
    { header: 'RATE', dataKey: 'rate' },
    { header: 'AMOUNT\nRs.     P.', dataKey: 'amount' }
  ];

  const body = order.items.map((item, index) => {
    const particulars = item.specification
      ? `${item.productName}\n${item.specification}`
      : item.productName;

    const qty = (item.pendingQuantity || item.quantity) || '';
    const unit = item.unit || 'pcs';
    const quantityWithUnit = qty ? `${qty} ${unit}` : '';

    return {
      sr: (startSerialNumber + index).toString(),
      particulars: particulars || 'N/A',
      quantity: quantityWithUnit,
      rate: '',
      amount: ''
    };
  });

  // Add summary rows to the body only if this is the last page
  if (isLastPage) {
    body.push(
      { sr: '', particulars: 'Transport Charge', quantity: '', rate: '', amount: '' },
      { sr: '', particulars: 'Loading/Unloading Charge', quantity: '', rate: '', amount: '' },
      { sr: '', particulars: 'Pre GST Amount', quantity: '', rate: '', amount: '' },
      { sr: '', particulars: 'GST', quantity: '', rate: '', amount: '' },
      { sr: '', particulars: 'TOTAL', quantity: '', rate: '', amount: '' }
    );
  }

  doc.autoTable({
    startY: tableStartY,
    margin: { left: leftMargin, right: 5 },
    head: [columns.map(col => col.header)],
    body: body.map(row => columns.map(col => row[col.dataKey])),
    theme: 'grid',
    tableWidth: 'auto',
    pageBreak: 'auto',
    showHead: 'everyPage',
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      halign: 'center',
      fontSize: 8,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      cellPadding: 2
    },
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      overflow: 'linebreak'
    },
    columnStyles: {
      0: { halign: 'center', cellWidth: 8, overflow: 'visible' },
      1: { halign: 'left', cellWidth: 62, overflow: 'linebreak' },
      2: { halign: 'center', cellWidth: 17, overflow: 'visible' },
      3: { halign: 'right', cellWidth: 20, overflow: 'visible' },
      4: { halign: 'right', cellWidth: 20, overflow: 'visible' }
    },
    didDrawCell: (data) => {
      // Make summary rows bold (only on last page)
      if (isLastPage) {
        const summaryStartIndex = order.items.length;
        if (data.section === 'body' && data.row.index >= summaryStartIndex && data.column.index === 1) {
          data.cell.styles.fontStyle = 'bold';
        }
        // Make TOTAL row extra bold
        if (data.section === 'body' && data.row.index === body.length - 1) {
          data.cell.styles.fontStyle = 'bold';
        }
      }
    }
  });
};

// Function to draw footer
const drawFooter = (doc) => {
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const leftMargin = 5;
  const rightMargin = pageWidth - 5;
  const footerY = pageHeight - 15;

  // Add "Received by" section
  const receivedY = footerY - 12;
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Received by: __________', leftMargin + 2, receivedY);
  doc.text('Date & Time: __________', leftMargin + 2, receivedY + 5);

  doc.setFontSize(6);
  doc.setFont('helvetica', 'normal');
  doc.text('Taxes as applicable', leftMargin, footerY);
  doc.text('Damaged goods to be returned', leftMargin, footerY + 3);
  doc.text('within 48hrs of delivery', leftMargin, footerY + 6);
  doc.text('Once lifted from the shop not taken back', leftMargin, footerY + 9);

  // Signature section - Right aligned in red
  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(200, 52, 43); // Red color
  doc.text('For Sai Plywood, Hardware &', rightMargin, footerY + 5, { align: 'right' });
  doc.text('Aluminium Centre', rightMargin, footerY + 9, { align: 'right' });
};

export const generateDeliveryChallan = (order, customer, site) => {
  // Create PDF in A5 portrait mode
  // A5 portrait: 148mm x 210mm
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a5'
  });

  const maxItemsPerPage = 10; // Max items per page (including summary)
  const summaryRowsCount = 5;
  const maxItemsOnLastPage = maxItemsPerPage - summaryRowsCount; // 5 items max on last page
  const minItemsOnLastPage = 2; // Min 2 items on last page (7 total with summary)

  // Split items into chunks
  const totalItems = order.items.length;

  // Calculate pagination
  let itemsPerPage;
  let totalPages;

  if (totalItems <= maxItemsOnLastPage) {
    // All items fit on one page with summary
    itemsPerPage = totalItems;
    totalPages = 1;
  } else {
    // Multiple pages needed
    const itemsBeforeLastPage = totalItems - maxItemsOnLastPage;
    totalPages = Math.ceil(itemsBeforeLastPage / maxItemsPerPage) + 1;

    // Check if last page would have too few items
    const remainingItems = totalItems - (totalPages - 1) * maxItemsPerPage;
    if (remainingItems < minItemsOnLastPage) {
      // Redistribute: reduce items per page to ensure last page has enough
      itemsPerPage = Math.floor((totalItems - minItemsOnLastPage) / (totalPages - 1));
    } else if (remainingItems > maxItemsOnLastPage) {
      // Last page has too many items, add another page
      itemsPerPage = maxItemsPerPage;
    } else {
      itemsPerPage = maxItemsPerPage;
    }
  }

  for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
    if (pageIndex > 0) {
      doc.addPage();
    }

    // Calculate item range for this page
    let startIndex, endIndex;

    if (totalPages === 1) {
      // Single page: all items
      startIndex = 0;
      endIndex = totalItems;
    } else if (pageIndex === totalPages - 1) {
      // Last page: remaining items
      startIndex = pageIndex * itemsPerPage;
      endIndex = totalItems;
    } else {
      // Regular page
      startIndex = pageIndex * itemsPerPage;
      endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    }

    const pageItems = order.items.slice(startIndex, endIndex);

    // Create order copy with current page items
    const pageOrder = { ...order, items: pageItems };

    // Check if this is the last page
    const isLastPage = pageIndex === totalPages - 1;

    // Draw header
    drawHeader(doc, pageOrder, customer, site);

    // Draw item table (with summary only on last page)
    // Pass startIndex + 1 for serial number continuation (1-based indexing)
    drawItemTable(doc, pageOrder, isLastPage, startIndex + 1);

    // Draw footer
    drawFooter(doc);
  }

  // Save the PDF
  const fileName = `Delivery_Challan_${order.deliveryChallanNumber || order.orderNumber || 'ORDER'}.pdf`;
  doc.save(fileName);
};
